import React from 'react';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { observer } from 'mobx-react';
import { useStores } from '../../../stores';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

const PopUpNotifer = observer(() => {
  const navigationStore = useStores().navigationStore;

  return (
    <div
      style={{
        width: '100%',
        height: '69px',
        backgroundColor: patientAccessTheme.palette.grey[300],
        boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.08)',
        padding: '0px 64px',
        display: navigationStore.isPopUpNotifierOpen ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography
        fontSize="14px"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.highemphasis}
      >
        Please make sure that there are no blockers enabled on your system
      </Typography>
      <Button
        label={'Close'}
        variant="outlined"
        style={{
          padding: '10px 20px',
          width: '115px',
          height: '37px',
          border: `1px solid ${patientAccessTheme.palette.primary[500]}`,
          borderRadius: '4px',
          textTransform: 'none',
          fontSize: '14px',
          lineHeight: '17px',
          fontWeight: 500,
        }}
        onClick={() => navigationStore.handleOpenPopUpNotifier(false)}
      />
    </div>
  );
});

export default PopUpNotifer;
